import { useContext } from 'react';
import { AuthContext } from 'src/contexts/AuthContext';

export const useAuth = () => {
  return useContext(AuthContext);
};

export const useActionsAccess = () => {
  const { user } = useAuth();

  const isReadOnly = !!user?.franchiseeId;
  const franchiseeId = user?.franchiseeId ?? null;

  return { isReadOnly, franchiseeId };
};
